import image from "@/constants/image";
import { APP_ROUTES } from "@/constants/routes";
import { HeaderProps, useChatContext } from "@copilotkit/react-ui";
import { Box, Button } from "@mui/material";
import { useLocale } from "next-intl";
import Image from "next/image";
import Link from "next/link";

const Header = ({}: HeaderProps) => {
  const { setOpen, icons, labels } = useChatContext();
  const locale = useLocale();
  return (
    <div className="flex pl-6 pt-4 pr-6 pb-4 justify-between items-center bg-white">
      <Box className="flex gap-4 justify-center items-center">
        <Link
          href={APP_ROUTES(locale).HOME.to}
          className="flex items-center justify-center popup-assistant-header-logo-link"
        >
          <Image src={image.logoAi} alt="Logo AI" className="w-6 h-6" />
        </Link>
        <Box
          sx={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontStyle: "Semi Bold",
            fontSize: "18px",
            leadingTrim: "NONE",
            lineHeight: "100%",
            letterSpacing: "0%",
          }}
          className="text-cimigoBlue"
        >
          {labels.title}
        </Box>
      </Box>
      <div className="flex justify-end">
        <Button
          className="!text-[#A4A4A4] hover:!text-[#5d5d5d]"
          onClick={() => setOpen(false)}
          aria-label="Close"
        >
          {icons.headerCloseIcon}
        </Button>
      </div>
    </div>
  );
};

export default Header;
